import Vue from "vue";
import VueRouter from "vue-router";
const OutletSearch = () => import(/* webpackChunkName: "Home" */ '../views/Home');
Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        redirect: { name: 'OutletSearch' },
        meta: {
          title: '',
      }
    },
    {
        path: "/outletSearch",
        name: "OutletSearch",
        component: OutletSearch,
        meta: {
          title: '',
      }
    },
];
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (location) {
    return originalReplace.call(this, location).catch(err => err)
}

const router = new VueRouter({
    routes,
});

export default router;
